var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              staticClass: "modal_medium",
              attrs: { persistent: "" },
              model: {
                value: _vm.visible,
                callback: function ($$v) {
                  _vm.visible = $$v
                },
                expression: "visible",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _c("span", { staticClass: "headl" }, [
                      _vm._v("LECTURA MASIVA"),
                    ]),
                  ]),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-stepper",
                        {
                          staticClass: "mt-6",
                          model: {
                            value: _vm.stepReading,
                            callback: function ($$v) {
                              _vm.stepReading = $$v
                            },
                            expression: "stepReading",
                          },
                        },
                        [
                          _c(
                            "v-stepper-header",
                            [
                              _c(
                                "v-stepper-step",
                                {
                                  attrs: {
                                    complete: _vm.stepReading > 1,
                                    step: "1",
                                  },
                                },
                                [_vm._v(" Buscar Dispositivos ")]
                              ),
                              _c("v-stepper-step", { attrs: { step: "2" } }, [
                                _vm._v(" Realizar lecturas "),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "v-stepper-items",
                            [
                              _c(
                                "v-stepper-content",
                                { attrs: { step: "1" } },
                                [
                                  _c(
                                    "v-form",
                                    {
                                      ref: "form",
                                      attrs: {
                                        method: "post",
                                        enctype: "multipart/form-data",
                                        "lazy-validation": "",
                                      },
                                      model: {
                                        value: _vm.valid,
                                        callback: function ($$v) {
                                          _vm.valid = $$v
                                        },
                                        expression: "valid",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                cols: "12",
                                                sm: "6",
                                                md: "6",
                                              },
                                            },
                                            [
                                              _c("v-combobox", {
                                                ref: "company",
                                                attrs: {
                                                  items: _vm.itemsCompany,
                                                  "search-input": _vm.search,
                                                  "item-value": "_id",
                                                  "item-text": "name",
                                                  label: "Empresa",
                                                  placeholder:
                                                    "Digite el nombre de la empresa",
                                                  disabled: _vm.isMaster == 0,
                                                  clearable: "",
                                                  rules: _vm.nameRules,
                                                },
                                                on: {
                                                  "update:searchInput":
                                                    function ($event) {
                                                      _vm.search = $event
                                                    },
                                                  "update:search-input":
                                                    function ($event) {
                                                      _vm.search = $event
                                                    },
                                                  input: _vm.clearLists,
                                                },
                                                model: {
                                                  value: _vm.form.company,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "company",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.company",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                cols: "12",
                                                sm: "6",
                                                md: "6",
                                              },
                                            },
                                            [
                                              _c("v-select", {
                                                ref: "subTypeService",
                                                attrs: {
                                                  items: [
                                                    "Agua",
                                                    "Gas",
                                                    "Energia",
                                                  ],
                                                  label: "Tipo",
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.subTypeService,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "subTypeService",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.subTypeService",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                cols: "12",
                                                sm: "6",
                                                md: "6",
                                              },
                                            },
                                            [
                                              _c("v-autocomplete", {
                                                ref: "social",
                                                attrs: {
                                                  items: _vm.socialSelect,
                                                  "search-input":
                                                    _vm.searchSocial,
                                                  "item-value": "_id",
                                                  "item-text": "name",
                                                  label: "Estrato",
                                                  placeholder:
                                                    "selecciona el estrato",
                                                  clearable: "",
                                                },
                                                on: {
                                                  "update:searchInput":
                                                    function ($event) {
                                                      _vm.searchSocial = $event
                                                    },
                                                  "update:search-input":
                                                    function ($event) {
                                                      _vm.searchSocial = $event
                                                    },
                                                },
                                                model: {
                                                  value: _vm.form.socialgroup,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "socialgroup",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.socialgroup",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                cols: "12",
                                                sm: "6",
                                                md: "6",
                                              },
                                            },
                                            [
                                              _c("v-autocomplete", {
                                                ref: "zone",
                                                attrs: {
                                                  items: _vm.zoneSelect,
                                                  "search-input":
                                                    _vm.searchZone,
                                                  "item-value": "_id",
                                                  "item-text": "name",
                                                  label: "Zona",
                                                  placeholder:
                                                    "selecciona la zona",
                                                  clearable: "",
                                                },
                                                on: {
                                                  "update:searchInput":
                                                    function ($event) {
                                                      _vm.searchZone = $event
                                                    },
                                                  "update:search-input":
                                                    function ($event) {
                                                      _vm.searchZone = $event
                                                    },
                                                },
                                                model: {
                                                  value: _vm.form.zone,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "zone",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.zone",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                cols: "12",
                                                sm: "6",
                                                md: "6",
                                              },
                                            },
                                            [
                                              _c("v-autocomplete", {
                                                ref: "road",
                                                attrs: {
                                                  items: _vm.roadSelect,
                                                  "search-input":
                                                    _vm.searchRoad,
                                                  "item-value": "_id",
                                                  "item-text": "name",
                                                  label: "Ruta",
                                                  placeholder:
                                                    "selecciona la ruta",
                                                  clearable: "",
                                                },
                                                on: {
                                                  "update:searchInput":
                                                    function ($event) {
                                                      _vm.searchRoad = $event
                                                    },
                                                  "update:search-input":
                                                    function ($event) {
                                                      _vm.searchRoad = $event
                                                    },
                                                },
                                                model: {
                                                  value: _vm.form.road,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "road",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.road",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                cols: "12",
                                                sm: "6",
                                                md: "6",
                                              },
                                            },
                                            [
                                              _c("v-autocomplete", {
                                                ref: "cycle",
                                                attrs: {
                                                  items: _vm.cycleSelect,
                                                  "search-input":
                                                    _vm.searchCycle,
                                                  "item-value": "_id",
                                                  "item-text": "name",
                                                  label: "Ciclo",
                                                  placeholder:
                                                    "selecciona el ciclo",
                                                  clearable: "",
                                                },
                                                on: {
                                                  "update:searchInput":
                                                    function ($event) {
                                                      _vm.searchCycle = $event
                                                    },
                                                  "update:search-input":
                                                    function ($event) {
                                                      _vm.searchCycle = $event
                                                    },
                                                  change: _vm.defaultDate,
                                                },
                                                model: {
                                                  value: _vm.form.cycle,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "cycle",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.cycle",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-stepper-content",
                                { attrs: { step: "2" } },
                                [
                                  _c(
                                    "v-form",
                                    {
                                      ref: "form2",
                                      attrs: {
                                        method: "post",
                                        enctype: "multipart/form-data",
                                        "lazy-validation": "",
                                      },
                                      model: {
                                        value: _vm.valid2,
                                        callback: function ($$v) {
                                          _vm.valid2 = $$v
                                        },
                                        expression: "valid2",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                cols: "12",
                                                sm: "12",
                                                md: "12",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "ctn_take_read px-5",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "take_read_colum",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "copy_read_colum",
                                                        },
                                                        [
                                                          _c("h2", [
                                                            _vm._v(
                                                              "DISPOSITIVOS"
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "take_read_colum",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "copy_read_colum",
                                                        },
                                                        [
                                                          _c("h3", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.DeviceNumber
                                                                ) +
                                                                " "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "mt-0 mb-2" },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _vm.form.cycle == null
                                                ? _c(
                                                    "v-container",
                                                    {
                                                      staticClass: "pl-4",
                                                      attrs: { fluid: "" },
                                                    },
                                                    [
                                                      _c("v-switch", {
                                                        staticClass: "mt-0",
                                                        attrs: {
                                                          label:
                                                            "Usar fechas de ciclos",
                                                          dense: "",
                                                          "hide-details": "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.useCycleDates,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.useCycleDates =
                                                              $$v
                                                          },
                                                          expression:
                                                            "useCycleDates",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "mt-0" },
                                        [
                                          _c(
                                            "v-expand-transition",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.useCycleDates,
                                                      expression:
                                                        "useCycleDates",
                                                    },
                                                  ],
                                                  staticClass: "pt-0",
                                                  attrs: { cols: "12" },
                                                },
                                                [
                                                  _c(
                                                    "v-card",
                                                    { staticClass: "mx-1" },
                                                    [
                                                      _c("v-card-text", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "mr-4",
                                                                attrs: {
                                                                  color:
                                                                    "blue darken-2",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-information"
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-0 info--text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Si el ciclo del dispositivo no tiene rango de fecha parametrizado se usará el siguiente rango por defecto: "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "colm_custom",
                                              attrs: {
                                                cols: "12",
                                                sm: "12",
                                                md: "6",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-menu",
                                                {
                                                  attrs: {
                                                    "close-on-content-click": false,
                                                    "nudge-right": 40,
                                                    transition:
                                                      "scale-transition",
                                                    "offset-y": "",
                                                    "min-width": "auto",
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "v-text-field",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  ref: "date-init",
                                                                  attrs: {
                                                                    label:
                                                                      "Fecha Inicial",
                                                                    "prepend-icon":
                                                                      "mdi-calendar",
                                                                    readonly:
                                                                      "",
                                                                    dense: "",
                                                                    "hide-details":
                                                                      "",
                                                                    required:
                                                                      "",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.dateIni,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.dateIni =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "dateIni",
                                                                  },
                                                                },
                                                                "v-text-field",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            )
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ]),
                                                  model: {
                                                    value: _vm.datePicker1,
                                                    callback: function ($$v) {
                                                      _vm.datePicker1 = $$v
                                                    },
                                                    expression: "datePicker1",
                                                  },
                                                },
                                                [
                                                  _c("v-date-picker", {
                                                    ref: "date-init",
                                                    attrs: {
                                                      max: new Date()
                                                        .toISOString()
                                                        .substr(0, 10),
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        _vm.datePicker1 = false
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.dateIni,
                                                      callback: function ($$v) {
                                                        _vm.dateIni = $$v
                                                      },
                                                      expression: "dateIni",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "colm_custom",
                                              attrs: {
                                                cols: "12",
                                                sm: "12",
                                                md: "6",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-menu",
                                                {
                                                  attrs: {
                                                    "close-on-content-click": false,
                                                    "nudge-right": 40,
                                                    transition:
                                                      "scale-transition",
                                                    "offset-y": "",
                                                    "min-width": "auto",
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "v-text-field",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  ref: "date-dateEnd",
                                                                  attrs: {
                                                                    label:
                                                                      "Fecha Final",
                                                                    "prepend-icon":
                                                                      "mdi-calendar",
                                                                    readonly:
                                                                      "",
                                                                    dense: "",
                                                                    "hide-details":
                                                                      "",
                                                                    required:
                                                                      "",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.dateEnd,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.dateEnd =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "dateEnd",
                                                                  },
                                                                },
                                                                "v-text-field",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            )
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ]),
                                                  model: {
                                                    value: _vm.datePicker2,
                                                    callback: function ($$v) {
                                                      _vm.datePicker2 = $$v
                                                    },
                                                    expression: "datePicker2",
                                                  },
                                                },
                                                [
                                                  _c("v-date-picker", {
                                                    ref: "date-dateEnd",
                                                    attrs: {
                                                      min: new Date(_vm.dateIni)
                                                        .toISOString()
                                                        .substr(0, 10),
                                                      max: new Date()
                                                        .toISOString()
                                                        .substr(0, 10),
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        _vm.datePicker2 = false
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.dateEnd,
                                                      callback: function ($$v) {
                                                        _vm.dateEnd = $$v
                                                      },
                                                      expression: "dateEnd",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                cols: "12",
                                                sm: "6",
                                                md: "6",
                                              },
                                            },
                                            [
                                              _c("v-autocomplete", {
                                                ref: "period",
                                                attrs: {
                                                  items: _vm.periodSelect,
                                                  "search-input":
                                                    _vm.searchPeriod,
                                                  "item-value": "_id",
                                                  "item-text": "name",
                                                  label: "Periodo",
                                                  placeholder:
                                                    "Selecciona el periodo",
                                                  rules: _vm.nameRules,
                                                  clearable: "",
                                                },
                                                on: {
                                                  "update:searchInput":
                                                    function ($event) {
                                                      _vm.searchPeriod = $event
                                                    },
                                                  "update:search-input":
                                                    function ($event) {
                                                      _vm.searchPeriod = $event
                                                    },
                                                },
                                                model: {
                                                  value: _vm.form.period,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "period",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.period",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "div",
                        { staticClass: "ctn_btn_shop" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { large: "", text: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  _vm.show = false
                                },
                              },
                            },
                            [_vm._v("Cerrar")]
                          ),
                          _vm.stepReading == 1
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    disabled: !_vm.valid,
                                    loading: _vm.loadingCalculate,
                                    depressed: "",
                                    large: "",
                                    color: "secondary",
                                  },
                                  on: { click: _vm.calcular },
                                },
                                [_vm._v("CALCULAR")]
                              )
                            : _vm._e(),
                          _vm.stepReading == 2
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    disabled: !_vm.valid2 || _vm.loadingReading,
                                    loading: _vm.loadingReading,
                                    depressed: "",
                                    large: "",
                                    color: "primary",
                                  },
                                  on: { click: _vm.validate },
                                },
                                [_vm._v("TOMAR LECTURA")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }